import { Button, ConfirmationDialog, useDialogState } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ContentSharingType } from '@tabeeb/enums'
import { completeReview } from '@tabeeb/modules/contentReviews/actions'
import { getFormButtonState } from '@tabeeb/modules/forms/selectors'
import { getMergeReviewWithCurrentForm } from '@tabeeb/modules/contentReviews/selectors'

import { FormButtons } from '../../services/enums'

const CompleteReviewButton = () => {
  const dispatch = useDispatch()

  const [isCopyDialogOpen, onOpenCopyDialog, onCloseCopyDialog] = useDialogState()
  const [isMergeDialogOpen, onOpenMergeDialog, onCloseMergeDialog] = useDialogState()

  const { isDisabled } = useSelector((state) => getFormButtonState(state, { button: FormButtons.CompleteReview }))
  const currentFormReview = useSelector(getMergeReviewWithCurrentForm)

  const isMergeForReview = currentFormReview?.Type === ContentSharingType.MergeForReview

  const handleCompleteReview = (isCopyRequired: boolean) => {
    dispatch(completeReview({ isCopyRequired }))
    onCloseCopyDialog()
    onCloseMergeDialog()
  }

  return (
    <>
      <Button
        color='primary'
        size='small'
        disabled={isDisabled}
        variant='contained'
        fullWidth
        onClick={isMergeForReview ? onOpenMergeDialog : onOpenCopyDialog}
      >
        Complete review
      </Button>
      <ConfirmationDialog
        onCloseDialog={onCloseCopyDialog}
        onSubmit={() => handleCompleteReview(true)}
        onReject={() => handleCompleteReview(false)}
        isOpen={isCopyDialogOpen}
        title='Complete Review'
        dialogMessage={
          'Once complete this review, you will no longer be able to send ' +
          'feedback. Do you want a copy of this session to be created and added to your sessions ' +
          'page?'
        }
        showCloseIcon
        submitButtonText='Copy'
        cancelButtonText="Don't copy"
      />
      <ConfirmationDialog
        onCloseDialog={onCloseMergeDialog}
        onSubmit={() => handleCompleteReview(false)}
        onReject={onCloseMergeDialog}
        isOpen={isMergeDialogOpen}
        title='Complete Review'
        dialogMessage='Once this review is complete, you will no longer be able to send feedback. Please confirm to complete this review'
        showCloseIcon
        submitButtonText='Complete'
        cancelButtonText='Close'
      />
    </>
  )
}

export default CompleteReviewButton

